// extracted by mini-css-extract-plugin
export default {"menu":"styles_menu__XuprJ","menu__options":"styles_menu__options__zBqAp"};